package top.wcpe.allincore.dsl.compiler.lex

import top.wcpe.allincore.dsl.compiler.diag.DslError
import top.wcpe.allincore.dsl.compiler.source.SourcePosition

/**
 * 词法分析阶段抛出的异常。位置信息由 [position] 字段结构化保存，不拼入 message。
 */
class LexException(
    message: String,
    val position: SourcePosition,
    val error: DslError? = null,
) : RuntimeException(message)
